import * as React from 'react';
import { columns } from './columns';
import Table from '../../../../components/_table/Table/Table';
import { HomeTab } from '../../../../types/home/tab';
import { AntdColumn } from '../../../../types/common/table';
import { HOME_TAB_LINK_TYPE_V2 } from '../../../../constants/service/app/homeConstantsV2';

interface HomeTabListTableProps {
  list: HomeTab[];
  onChangeTabStatus: (id: number, checked: boolean) => void;
  onClickEdit: (id: number) => void;
  onChangeTabListOrder: ({ list, idList }: { list: HomeTab[]; idList: number[] }) => void;
}

const HomeTabListTable = (props: HomeTabListTableProps): JSX.Element => {
  const { list, onChangeTabListOrder, onChangeTabStatus, onClickEdit } = props;

  return (
    <Table
      columns={(): AntdColumn<HomeTab>[] => columns({ onChangeTabStatus, onClickEdit })}
      rowKey={(record: { id: number }): number => record.id}
      list={list.map((item) => ({ ...item, rowCanDrag: item.linkType !== HOME_TAB_LINK_TYPE_V2.MAIN }))}
      size="small"
      scroll={{ x: true }}
      bordered={true}
      canDrag={true}
      onDragEnd={onChangeTabListOrder}
      showPagination={false}
    />
  );
};

export default HomeTabListTable;
